import * as React from "react";
import { DataGrid, deDE, GridColDef } from "@mui/x-data-grid";
import useLicensesQuery from "../hooks/useLicensesQuery";
import useClientQuery from "../../../global/queries/useClientQuery";
import { PC } from "../../../global/interfaces/Client";

export default function LicensesDataTable() {
  const { data: client } = useClientQuery();
  const { data: licences } = useLicensesQuery();

  const columns: GridColDef[] = [
    { field: "number", headerName: "PC-Nummer", flex: 1 },
    { field: "comment", headerName: "PC-Kommentar", flex: 1 },
    { field: "activationDate", headerName: "Aktiviert am", flex: 1 },
  ];

  if (!licences) return <h1>undefined</h1>;

  return (
    <DataGrid
      localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
      sx={{ minHeight: 500, marginTop: 2 }}
      rows={client?.pcs || []}
      columns={columns}
      getRowId={(row) => row.number}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      pageSizeOptions={[5]}
      disableRowSelectionOnClick
    />
  );
}
